import { render, staticRenderFns } from "./CreateReminderButton.vue?vue&type=template&id=a415f7ae&scoped=true&"
import script from "./CreateReminderButton.vue?vue&type=script&lang=js&"
export * from "./CreateReminderButton.vue?vue&type=script&lang=js&"
import style0 from "./CreateReminderButton.vue?vue&type=style&index=0&id=a415f7ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a415f7ae",
  null
  
)

export default component.exports